import { render } from "./delete.vue?vue&type=template&id=8fdc69f0"
import script from "./delete.vue?vue&type=script&lang=js"
export * from "./delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__